import { render, staticRenderFns } from "./TServTopListComp.vue?vue&type=template&id=289f2f09&"
import script from "./TServTopListComp.vue?vue&type=script&lang=js&"
export * from "./TServTopListComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports